import React, { useEffect, useState } from "react";
import Breadcrumb from "../../components/Breadcrumb";
import { api } from "../../utils/apiClient";
import LoadingShimmer from "../../utils/LoadingShimmer";
import { Icon } from "@iconify/react/dist/iconify.js";
import ArticlesTable from "../../components/tables/ArticlesTable";
import { toast } from "react-toastify";
import { showDeleteConfirm } from "../../utils/deleteConfirm";

let searchTimeout;

const ArticlesPage = () => {
    const [articles, setArticles] = useState([]);
    const [loading, setLoading] = useState(true);

    // pagination
    const [page, setPage] = useState(1);
    const [limit] = useState(10);
    const [totalPages, setTotalPages] = useState(1);
    const [totalEntries, setTotalEntries] = useState(0);

    // sort
    const [sort, setSort] = useState("created_at");
    const [order, setOrder] = useState("desc");

    // search
    const [search, setSearch] = useState("");
    const [debouncedSearch, setDebouncedSearch] = useState("");

    const [entriesPerPage, setEntriesPerPage] = useState(10);

    const fetchArticles = async () => {
        try {
            setLoading(true);

            const response = await api.get("/articles", {
                params: {
                    page,
                    per_page: entriesPerPage,
                    sort,
                    order,
                    search: debouncedSearch?.trim() || "",
                },
            });

            setArticles(response.data.data || []);
            setTotalPages(response.data.total_pages || 1);
            setTotalEntries(response.data.total_entries || 0);
        } catch (error) {
            console.error("Error fetching articles:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        clearTimeout(searchTimeout);
        searchTimeout = setTimeout(() => {
            setDebouncedSearch(search);
            setPage(1);
        }, 1000);

        return () => clearTimeout(searchTimeout);
    }, [search]);

    useEffect(() => {
        fetchArticles();
    }, [page, entriesPerPage, sort, order, debouncedSearch]);

    const handleRefresh = () => {
        fetchArticles();
    };

    const handleDelete = async (id) => {
        try {
            await api.delete(`/articles/${id}`);
            setArticles(prev => prev.filter(item => item.id !== id));
            toast.success("Article deleted successfully");

        } catch (error) {
            console.error("Delete failed:", error);
            toast.error("Failed to delete event item");
        }
    };

    const handleDeleteClick = (id) => {
        showDeleteConfirm(() => handleDelete(id));
    };


    return (
        <>
            <div className="page-header-row">
                <Breadcrumb title="Articles" />

                <div className="filter-wrapper">
                    <Icon
                        icon="mdi:refresh"
                        width="26"
                        height="26"
                        className={`ms-2 d-inline-flex d-md-none mobile-refresh-icon ${loading ? "spin" : ""}`}
                        onClick={handleRefresh}
                    />
                </div>
            </div>

            {loading ? (
                <LoadingShimmer
                    columns={8}
                    rows={6}
                    avatarColumnIndex={2}
                    actionColumnIndex={7}
                />
            ) : (
                <ArticlesTable
                    articles={articles}
                    page={page}
                    setPage={setPage}
                    totalPages={totalPages}
                    totalEntries={totalEntries}
                    sort={sort}
                    order={order}
                    setSort={setSort}
                    setOrder={setOrder}
                    search={search}
                    setSearch={setSearch}
                    entriesPerPage={entriesPerPage}
                    setEntriesPerPage={setEntriesPerPage}
                    fetchArticles={fetchArticles}
                    onDelete={handleDeleteClick}
                />
            )}
        </>
    );
};

export default ArticlesPage;